var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',[_vm._v("Download Product Types")]),_c('v-card-text',[_c('v-btn',{staticClass:"mr-4",attrs:{"color":"success"},on:{"click":function($event){return _vm.downloadProductTypes(false)}}},[_vm._v(" Download ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }